(() => {
  // Run on collections + search (path-based; your theme body lacks template classes)
  const isCollectionOrSearch =
    location.pathname.includes("/collections/") ||
    location.pathname.startsWith("/search") ||
    location.pathname.includes("/search");

  if (!isCollectionOrSearch) return;

  function looksLikeLinkBlue(colorStr) {
    if (!colorStr) return false;
    const c = colorStr.replace(/\s+/g, "").toLowerCase();
    return (
      c === "rgb(0,0,238)" ||
      c === "rgb(0,0,255)" ||
      c === "#0000ee" ||
      c === "#0000ff"
    );
  }

  function getBaselinePriceColor() {
    const candidates = [".price .price-item", ".price-item", ".price"];
    for (const sel of candidates) {
      const els = Array.from(document.querySelectorAll(sel));
      for (const el of els) {
        if (el.closest("[samitaws-product-id],[samitaws-variant-id]")) continue;
        const col = getComputedStyle(el).color;
        if (col && !looksLikeLinkBlue(col)) return col;
      }
    }
    return null;
  }

  let baselineColor = null;

  function findCardRoot(node) {
    return (
      node.closest?.(".card-wrapper") ||
      node.closest?.(".grid__item") ||
      node.closest?.("li") ||
      node.closest?.("div")
    );
  }

  function clampTitle(card) {
    // Dawn varies by version; cover common title selectors
    const titleLink =
      card.querySelector(".card__heading a") ||
      card.querySelector(".card__heading") ||
      card.querySelector(".card__information .card__heading") ||
      card.querySelector(".card__content .card__heading");

    if (!titleLink) return;

    // Clamp visually to 2 lines, reserve consistent height
    if (!titleLink.dataset.tmrTitleClamp) {
      titleLink.style.display = "-webkit-box";
      titleLink.style.webkitBoxOrient = "vertical";
      titleLink.style.webkitLineClamp = "2";
      titleLink.style.overflow = "hidden";

      // Reserve space for 2 lines so price/buttons align across cards
      titleLink.style.lineHeight = "1.2";
      titleLink.style.minHeight = "2.4em"; // 2 lines * 1.2 line-height
      titleLink.dataset.tmrTitleClamp = "1";
    }
  }

  function stabilizeCardLayout(card) {
    if (!card) return;

    const info =
      card.querySelector(".card__information") ||
      card.querySelector(".card__content") ||
      card;

    // Clamp title to keep consistent height above pricing
    clampTitle(card);

    // Force vertical stacking + full height so margin-top:auto can pin CTA
    if (info && !info.dataset.tmrSamiFlex) {
      info.style.display = "flex";
      info.style.flexDirection = "column";
      info.style.height = "100%";
      info.dataset.tmrSamiFlex = "1";
    }

    const samiBlock =
      card.querySelector("[samitaws-product-id]") ||
      card.querySelector("[samitaws-variant-id]");

    if (samiBlock) {
      // Instead of display:none (can cause subtle differences),
      // collapse native price spacing gently
      const nativePrice = card.querySelector(".price");
      if (nativePrice && !nativePrice.contains(samiBlock) && !nativePrice.dataset.tmrSamiCollapsed) {
        nativePrice.style.margin = "0";
        nativePrice.style.padding = "0";
        nativePrice.style.minHeight = "0";
        nativePrice.style.height = "0";
        nativePrice.style.overflow = "hidden";
        nativePrice.dataset.tmrSamiCollapsed = "1";
      }

      if (!samiBlock.dataset.tmrSamiMinHeight) {
        samiBlock.style.display = "block";
        samiBlock.style.minHeight = "3.00em";
        samiBlock.style.lineHeight = "1.1";
        samiBlock.style.display = "flex";
        samiBlock.style.alignItems = "center";   // vertically centers price within reserved space
        samiBlock.style.margin = "0";
        samiBlock.style.padding = "0";

        samiBlock.style.whiteSpace = "normal";
        samiBlock.dataset.tmrSamiMinHeight = "1";
        // Always apply (so changes take effect without needing a fresh DOM node)
samiBlock.style.paddingTop = "2px";   // try 2px–4px
samiBlock.style.paddingBottom = "0px";

      }
    }

    // Pin the CTA area to bottom
    const buttonWrap =
      card.querySelector(".quick-add") ||
      card.querySelector(".card__button") ||
      card.querySelector("product-form") ||
      card.querySelector('button[name="add"]')?.closest("div");

    if (buttonWrap && !buttonWrap.dataset.tmrSamiPinned) {
      buttonWrap.style.marginTop = "auto";
      buttonWrap.dataset.tmrSamiPinned = "1";
    }
  }

  function applyPriceColorFix(card) {
    if (!card) return;

    const themePriceEl =
      Array.from(card.querySelectorAll(".price, .price-item, .price__container"))
        .find((el) => !el.closest("[samitaws-product-id],[samitaws-variant-id]")) ||
      card.querySelector(".card__heading") ||
      card;

    let intendedColor = themePriceEl ? getComputedStyle(themePriceEl).color : null;

    if (!baselineColor || looksLikeLinkBlue(baselineColor)) {
      const b = getBaselinePriceColor();
      if (b) baselineColor = b;
    }

    if (!intendedColor || looksLikeLinkBlue(intendedColor)) {
      if (baselineColor) intendedColor = baselineColor;
    }

    const original = card.querySelector(".samitaWS-customized-original-price");
    const sale = card.querySelector(".samitaWS-customized-price");

    const samiBlock =
      card.querySelector("[samitaws-product-id]") ||
      card.querySelector("[samitaws-variant-id]");
    if (samiBlock) {
      samiBlock.style.whiteSpace = "normal";
      samiBlock.style.display = "block";
    }

    if (original) {
      if (intendedColor) original.style.setProperty("color", intendedColor, "important");
      original.style.setProperty("opacity", "0.6", "important");
      original.style.setProperty("text-decoration", "line-through", "important");
      original.style.setProperty("margin-right", "6px", "important");
      original.style.setProperty("display", "inline", "important");
    }

    if (sale) {
      if (intendedColor) sale.style.setProperty("color", intendedColor, "important");
      sale.style.setProperty("text-decoration", "none", "important");
      sale.style.setProperty("display", "inline", "important");
    }
  }

  function normalizeCardFromAnyNode(node) {
    const card = findCardRoot(node);
    if (!card) return;

    const hasSami =
      card.querySelector("[samitaws-product-id]") ||
      card.querySelector("[samitaws-variant-id]") ||
      card.querySelector(".samitaWS-customized-price") ||
      card.querySelector(".samitaWS-customized-original-price");

    if (!hasSami) return;

    stabilizeCardLayout(card);
    applyPriceColorFix(card);
  }

  function normalizeAllVisible() {
    document
      .querySelectorAll(
        "[samitaws-product-id], [samitaws-variant-id], .samitaWS-customized-price, .samitaWS-customized-original-price"
      )
      .forEach((el) => normalizeCardFromAnyNode(el));
  }

  setTimeout(normalizeAllVisible, 0);
  setTimeout(normalizeAllVisible, 250);
  setTimeout(normalizeAllVisible, 800);
  setTimeout(normalizeAllVisible, 1500);

  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (
          n.matches?.(
            "[samitaws-product-id], [samitaws-variant-id], .samitaWS-customized-price, .samitaWS-customized-original-price"
          ) ||
          n.querySelector?.(
            "[samitaws-product-id], [samitaws-variant-id], .samitaWS-customized-price, .samitaWS-customized-original-price"
          )
        ) {
          normalizeCardFromAnyNode(n);
        }
      }
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
